import { render, staticRenderFns } from "./f-select.vue?vue&type=template&id=1c19a36a&scoped=true&"
import script from "./f-select.vue?vue&type=script&lang=js&"
export * from "./f-select.vue?vue&type=script&lang=js&"
import style0 from "./f-select.vue?vue&type=style&index=0&id=1c19a36a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19a36a",
  null
  
)

export default component.exports